module.exports = __webpack_public_path__ + "img/B27744_5A2804_F6C488_EBB27D-256px.804d3760.png";